import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function getBIBar
 * @desc 案件柱状图
 * @returns {Object}
 */
const getBIBar = query => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/screen/echarts?${query}`)
    .then(checkResponse);
};

/**
 * @function getBIAreaRank
 * @desc 获取点位问题数排名
 * @returns {Object}
 */
const getBIAreaRank = query => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/ucase_ranked?rankedType=1&${query}`
    )
    .then(checkResponse);
};

/**
 * @function getBIStandardRank
 * @desc 获取指标问题数排名
 * @returns {Object}
 */
const getBIStandardRank = query => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/ucase_ranked?rankedType=2&${query}`
    )
    .then(checkResponse);
};

/**
 * @function getPrincipalRank
 * @desc 获取责任单位案件数排名
 * @returns {Object}
 */
const getPrincipalRank = query => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/unit_ranked?rankedType=1&${query}`
    )
    .then(checkResponse);
};

/**
 * @function getPrincipalRankSub
 * @desc 获取责任单位案件数排名
 * @returns {Object}
 */
const getPrincipalRankSub = query => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/unit_ranked_sub?rankedType=1&${query}`
    )
    .then(checkResponse);
};
/**
 * @function getBIDetail
 * @desc 获取问题/点位详情
 * @returns {Object}
 */
const getBIDetail = query => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/screen/detail?${query}`)
    .then(checkResponse);
};

/**
 * @function getBINav
 * @desc 获取导航
 * @returns {Object}
 */
const getBINav = query => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/screen/navigate?stage=1&${query}`)
    .then(checkResponse);
};

/**
 * @function getJSNav
 * @desc 获取导航
 * @returns {Object}
 */
const getJSNav = query => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/search/xc/navigate?stage=1&${query}`)
    .then(checkResponse);
};

/**
 * @function getActualUcaseList
 * @desc 获取实时案件动态
 * @returns {Object}
 */
const getActualUcaseList = () => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/screen/dynamic`)
    .then(checkResponse);
};

/**
 * @function getProjectInfoInBI
 * @desc 获取项目信息
 * @returns {Object}
 */
const getProjectInfoInBI = () => {
  return axios.get(`/api/v1/projects/${getProjectId()}`).then(checkResponse);
};

/**
 * @function getBIOriCase
 * @desc 业务科室未派发案件统计
 * @returns {Object}
 */
const getBIOriCase = query => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/search/group/oriName?${query}`)
    .then(checkResponse);
};

/**
 * @function getAreaDetailInfoInBI
 * @desc 获取点位详情信息
 * @returns {Object}
 */
const getAreaDetailInfoInBI = query => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/screen/area_detail?${query}`)
    .then(checkResponse);
};

/**
 * @function getCurrentDayMap
 * @desc 获取当天案件地图数据
 * @returns {Object}
 */
const getCurrentDayMap = search => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/ucases?datetimeFormat=datetime&pagination=false&${search}`
    )
    .then(checkResponse);
};

/**
 * @function getReadStatistics
 * @desc 获取已读未读统计
 * @returns {Object}
 */
const getReadStatistics = query => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/unread?${query}`
    )
    .then(checkResponse);
};

/**
 * @function getActivePoints
 * @desc 获取检查员点位
 * @returns {Object}
 */
const getActivePoints = time => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/tracks/getActivePoints${time ? `?time=${time}`:''}`
    )
    .then(checkResponse);
};

export{
  getActualUcaseList,
  getAreaDetailInfoInBI,
  getBIAreaRank,
  getBIBar,
  getBIDetail,
  getBINav,
  getBIOriCase,
  getBIStandardRank,
  getCurrentDayMap,
  getPrincipalRank,
  getProjectInfoInBI,
  getPrincipalRankSub,
  getReadStatistics,
  getActivePoints,
  getJSNav
}
